<template>
    <v-card>
        <v-toolbar class="toolbar-header-color">
            <v-toolbar-title>
                {{$t('subjectreportlist')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn dark text @click="dialogueClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-row>
                <v-col md="6" sm="6" cols="12">
                    <vue-good-table v-if="rows.length>0"
                                    :columns="columns"
                                    :rows="rows"
                                    mode="remote"
                                    styleClass="vgt-table condensed">
                        <template slot="table-column" slot-scope="props">
                            <span>
                                {{ $t(props.column.label) }}
                            </span>
                        </template>
                        <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'actions'">
                                <v-icon dense class="mr-2" @click.stop="subjectInfo(props.row)" style="color:dodgerblue">edit</v-icon>
                                <v-icon dense @click.stop="deletesubject(props.row)" style="color:red">delete  </v-icon>
                            </span>
                        </template>
                    </vue-good-table>
                </v-col>
                <v-col md="1" sm="1" cols="12" class="pt-8">
                    <button v-if="rows.length>0" @click.prevent="clearForm()">
                        <v-icon color="red" class="mr-2"> mdi-broom </v-icon>
                        {{$t('clear')}}
                    </button>
                </v-col>
                <v-col md="2" sm="2" cols="12" class="pt-8">
                    <v-select v-model.number="report.fiscalYearID" dense outlined
                              :items="fiscalYearList"
                              item-text="text"
                              item-value="value">
                        <template v-slot:label>
                            {{ $t("fiscal_year") }}
                        </template>
                    </v-select>
                </v-col>
                <v-col md="2" sm="2" cols="12" class="pt-8">
                    <v-select outlined dense
                              v-model.number="report.anusucharuReportID"
                              :items="anusucharuList"
                              item-text="value"
                              item-value="id">
                        <template v-slot:label>
                            {{ $t("anusuchi_Name") }}
                        </template>
                    </v-select>
                </v-col>
                <v-col md="1" sm="1" cols="12" class="pt-8">
                    <v-btn color="primary" @click.prevent="searchAnusuchi" dark>
                        <i class="material-icons">search</i>{{$t('search')}}
                    </v-btn>
                </v-col>
            </v-row>
            <v-dialog v-model="dialogDelete" max-width="500px">
                <deleteListData :deleteFormData="deleteFormData"
                                @formResponse="onResponseDelete"></deleteListData>
            </v-dialog>
            <v-dialog v-model="dialogIndexDelete" max-width="500px">
                <deleteSubjectData :deleteFormData="deleteFormData"
                                   @formResponse="onResponseClose"
                                   @deleteConfirmed="deleteConfirmed"></deleteSubjectData>
            </v-dialog>
            <v-dialog v-model="dialogProgramIndexDelete" max-width="500px">
                <deleteProgramData :deleteFormData="deleteFormData"
                                   @formResponse="onResponseProgramClose"
                                   @deleteConfirmed="deleteProgramConfirmed"></deleteProgramData>
            </v-dialog>
            <v-dialog v-model="dialogTargetIndexDelete" max-width="500px">
                <deleteTargetData :deleteFormData="deleteFormData"
                                  @formResponse="onResponseTargetClose"
                                  @deleteConfirmed="deleteTargetConfirmed"></deleteTargetData>
            </v-dialog>
            <v-dialog v-model="anusichiViewModal"
                      max-width="1000px"
                      transition="dialog-bottom-transition"
                      hide-overlay
                      fullscreen>
                <v-card>
                    <viewAnusucharuReport @dialogueCloseView="dialogueCloseView"
                                          @formResponse="formResponse"
                                          :aunusucharuData="aunusucharuData"
                                          v-if="viewAnusuchiComponent"
                                          ref="anusucharuReportView"></viewAnusucharuReport>

                </v-card>
            </v-dialog>
            <br />
            <form>
                <v-col md="12">
                    <v-card elevation="4">
                        <div class="sticky-div">
                            <table style="border-collapse:collapse;">
                                <thead>
                                    <tr>
                                        <th class="header-cell col-sm-1 col-md-1 col-12" rowspan="2">विषय</th>
                                        <th class="header-cell col-sm-2 col-md-2 col-12" rowspan="2">कार्यक्रम</th>
                                        <th class="header-cell col-sm-2 col-md-2 col-12" rowspan="2">लक्ष्य</th>
                                        <th class="header-cell col-sm-3 col-md-3 col-12" colspan="2">बजेट रु हजारमा</th>
                                        <th class="header-cell col-sm-1 col-md-1 col-12" rowspan="2">अनुसूची</th>
                                        <th class="header-cell col-sm-2 col-md-2 col-12" rowspan="2">उपलब्धि</th>
                                    </tr>
                                    <tr>
                                        <th class="header-cell col-sm-1 col-md-1 col-12">चालु</th>
                                        <th class="header-cell col-sm-1 col-md-1 col-12">पूँजीगत</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <div>
                            <v-row class="pt-3" v-for="(subject, subjectIndex) in subjects" :key="subjectIndex" :style="getSubjectRowStyle(subjectIndex)">
                                <v-col md="1" sm="1" cols="12">
                                    <v-select v-model.number="subject.subjectTitleID" outlined
                                              :items="subjectList"
                                              item-text="value"
                                              item-value="id">
                                        <template v-slot:label>
                                            {{ $t("enterSubject") }}
                                        </template>
                                    </v-select>

                                </v-col>
                                <v-col md="11" sm="11" cols="12">
                                    <v-row v-for="(program, programIndex) in subject.programs" :key="programIndex">
                                        <v-col md="3" sm="3" cols="12">
                                            <v-row>
                                                <v-col md="2" sm="2" cols="12">
                                                    <v-row class="pt-3" v-if="subjectIndex>0">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon @click.prevent="deleteSubjectIndex(subjectIndex)" color="red" v-on="on" v-bind="attrs"> mdi-delete </v-icon>
                                                            </template>
                                                            <span>{{ $t("enterSubject") }} {{ $t("delete") }}  </span>
                                                        </v-tooltip>
                                                    </v-row>
                                                    <v-row class="pt-3">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon @click.prevent="addProgram(subjectIndex)" color="green" v-on="on" v-bind="attrs"> mdi-plus </v-icon>
                                                            </template>
                                                            <span>{{ $t("enterProgram") }} {{ $t("add") }}  </span>
                                                        </v-tooltip>
                                                    </v-row>
                                                </v-col>
                                                <v-col md="8" sm="8" cols="12">
                                                    <v-text-field clearable
                                                                  outlined
                                                                  v-model="program.programName">
                                                        <template v-slot:label>
                                                            {{ $t("enterProgram") }}
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col md="2" sm="2" cols="12">
                                                    <v-row class="pl-4 pr-3 pt-3" v-if="!programIndex==0">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon @click.prevent="deleteProgram(subjectIndex,programIndex)" color="red" class="mr-2" v-on="on" v-bind="attrs"> mdi-delete </v-icon>
                                                            </template>
                                                            <span>{{ $t("enterProgram") }} {{ $t("delete") }}  </span>
                                                        </v-tooltip>
                                                    </v-row>
                                                    <v-row class="pl-4 pr-3 pt-3">
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon @click.prevent="addTarget(subjectIndex, programIndex)" color="green" v-on="on" v-bind="attrs">mdi-plus</v-icon>
                                                            </template>
                                                            <span>{{ $t("enterTarget") }} {{ $t("add") }}  </span>
                                                        </v-tooltip>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col md="9" sm="9" cols="12">
                                            <v-row v-for="(target, targetIndex) in program.targets" :key="targetIndex">
                                                <v-col md="3" sm="3" cols="12">
                                                    <v-text-field clearable
                                                                  outlined
                                                                  v-model="target.targetName">
                                                        <template v-slot:label>
                                                            {{ $t("enterTarget") }}
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col md="2" sm="2" cols="12">
                                                    <v-text-field clearable
                                                                  outlined
                                                                  type="number"
                                                                  v-model.number="target.currentAmount">
                                                        <template v-slot:label>
                                                            {{ $t("currentAmount") }}
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col md="2" sm="2" cols="12">
                                                    <v-text-field clearable
                                                                  outlined
                                                                  type="number"
                                                                  v-model.number="target.capitalAmount">
                                                        <template v-slot:label>
                                                            {{ $t("capital_Amount") }}
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col md="2" sm="2" cols="12">
                                                    <v-text-field clearable
                                                                  outlined
                                                                  v-model="target.anusuchiName">
                                                        <template v-slot:label>
                                                            {{ $t("anusuchi_Name") }}
                                                        </template>
                                                    </v-text-field>
                                                </v-col>
                                                <v-col md="3" sm="3" cols="12">
                                                    <v-row>
                                                        <v-col md="10" sm="10" cols="12">
                                                            <v-text-field clearable
                                                                          outlined
                                                                          v-model="target.achievement">
                                                                <template v-slot:label>
                                                                    {{ $t("achievement") }}
                                                                </template>
                                                            </v-text-field>

                                                        </v-col>
                                                        <v-col md="2" sm="2" cols="12">
                                                            <v-tooltip top v-if="!targetIndex==0">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-icon @click.prevent="deleteTarget(subjectIndex, programIndex, targetIndex)" color="red" class="mr-2" v-on="on" v-bind="attrs"> mdi-delete </v-icon>
                                                                </template>
                                                                <span>{{ $t("enterTarget") }} {{ $t("delete") }}  </span>
                                                            </v-tooltip>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row class="pl-4">
                                <v-col md="2" sm="6" cols="12">
                                    <button v-if="isInitial" @click.prevent="addSubject">
                                        {{ $t("enterSubject") }} {{ $t("add") }}
                                        <v-icon color="green" class="mr-2"> mdi-plus </v-icon>
                                    </button>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>
                </v-col>
            </form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="red darken-1" @click="dialogueClose">{{$t('cancel')}}</v-btn>
            <v-btn class="custom-save-button" v-if="isInitial" @click="formSubmit">{{$t('save')}}</v-btn>
            <v-btn class="custom-save-button" v-if="!isInitial" @click="formSubmitUpdate">{{$t('update')}}</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    import axios from "axios";
    import deleteListData from "@/components/deleteModal";
    import viewAnusucharuReport from "./ViewAnusucharuReport";
    import deleteSubjectData from "@/components/deleteViewModal";
    import deleteProgramData from "@/components/yearlyReportProgramdeleteModal";
    import deleteTargetData from "@/components/yearlyReportTargetdeleteModal";

    export default {
        name: "SubjectForm",
        components: {
            'deleteListData': deleteListData,
            'deleteSubjectData': deleteSubjectData,
            'deleteProgramData': deleteProgramData,
            'deleteTargetData': deleteTargetData,
            'viewAnusucharuReport': viewAnusucharuReport
        },
        props: ["subjectFormData"],
        data() {
            return {
                formData: {},
                message: {
                    status: true,
                    text: 'true',
                },
                subjectList: [],
                anusucharuList: [],
                fiscalYearList: [],
                isInitial: true,
                dialogDelete: false,
                dialogIndexDelete: false,
                dialogProgramIndexDelete: false,
                dialogTargetIndexDelete: false,
                anusichiViewModal: false,
                viewAnusuchiComponent: false,
                deleteFormData: {},
                aunusucharuData: {},
                report: {
                    fiscalYearID: 0,
                    anusucharuReportID: 0
                },
                subjects: [
                    {
                        fiscalYearID: this.subjectFormData.fiscalYearID,
                        subjectTitleID: 0,
                        programs: [
                            {
                                programName: '',
                                targets: [{
                                    targetName: '',
                                    currentAmount: 0,
                                    capitalAmount: 0,
                                    anusuchiName: '',
                                    achievement: '',
                                }]
                            }
                        ]
                    }
                ],
                columns: [
                    {
                        label: "name",
                        field: "name"
                    },
                    {
                        label: "actions",
                        field: "actions",
                        sortable: false
                    }
                ],
                rows: [],
            }
        },
        computed: {
        },
        methods: {
            dialogueClose() {
                this.formData = {}
                this.$emit('dialogueClose')
            },
            deletesubject(item) {
                this.dialogDelete = true;
                this.deleteFormData.url = "ReportSettings/DeletePoliciesProgramBudgetLevelTwoByIDandSubjectID/" + item.fiscalYearID + '/' + item.subjectTitleID;
                this.clearForm();
            },
            searchAnusuchi() {
                this.anusichiViewModal = true
                this.viewAnusuchiComponent = true
                let model = {
                    fiscalYearID: this.report.fiscalYearID,
                    anusucharuReportID: this.report.anusucharuReportID,
                }
                this.aunusucharuData = model;

                this.viewAnusuchiComponent
                this.$refs.anusucharuReportView.loadItems();
            },
            dialogueCloseView() {
                this.anusichiViewModal = false
                this.viewAnusuchiComponent = false
            },
            getSubjectRowStyle(subjectIndex) {
                const colors = ['#d3d3d3', '#ede8e8', '#d8e6e7', '#e4e2f5', '#f5f2e2', '#c1d1cb', '#c1c8d1', '#c4c1d1', '#f7e4e4']; // Define the desired color codes
                const backgroundColor = colors[subjectIndex % colors.length];
                return `background-color: ${backgroundColor}; margin:auto`;
            },
            formSubmit() {
                axios.post('ReportSettings/InsertPoliciesProgramBudgetLevelTwo', this.subjects)
                    .then(() => {
                        this.message.status = true
                        this.message.text = 'Subject is Successfully Updated'
                        this.$emit('formResponse', this.message)
                        this.dialogueClose()
                    })
                    .catch(() => {
                        this.message.status = false
                        this.message.text = 'Error Adding Subject, Please Contact Admin'
                        this.$emit('formResponse', this.message)
                    })
            },
            formSubmitUpdate() {
                axios.post('ReportSettings/UpdatePoliciesProgramBudgetLevelTwo', this.subjects)
                    .then(() => {
                        this.message.status = true
                        this.message.text = 'Subject is Successfully Updated'
                        this.$emit('formResponse', this.message)
                        this.dialogueClose()
                    })
                    .catch(() => {
                        this.message.status = false
                        this.message.text = 'Error Adding Subject, Please Contact Admin'
                        this.$emit('formResponse', this.message)
                    })
            },
            async loadItems() {
                axios.get("ReportSettings/DDLSubjectTitleList").then(response => {
                    this.subjectList = response.data
                })
                axios.get("AnusucharuReport/AnusucharuList").then(response => {
                    this.anusucharuList = response.data
                })
            },
            addTarget(subjectIndex, programIndex) {
                this.subjects[subjectIndex].programs[programIndex].targets.push(
                    {
                        targetName: '',
                        currentAmount: 0,
                        capitalAmount: 0,
                        anusuchiName: '',
                        achievement: '',
                    });
            },
            deleteTarget(subjectIndex, programIndex, targetIndex) {
                this.deleteFormData = {
                    subjectIndex: subjectIndex,
                    programIndex: programIndex,
                    targetIndex: targetIndex
                };
                this.dialogTargetIndexDelete = true;
            },
            deleteTargetConfirmed() {
                this.subjects[this.deleteFormData.subjectIndex].programs[this.deleteFormData.programIndex].targets.splice(this.deleteFormData.targetIndex, 1);
                this.dialogTargetIndexDelete = false;
            },
            onResponseTargetClose() {
                this.dialogTargetIndexDelete = false;
            },
            addProgram(subjectIndex) {
                this.subjects[subjectIndex].programs.push({
                    name: '',
                    targets: [{
                        targetName: '',
                        currentAmount: 0,
                        capitalAmount: 0,
                        anusuchiName: '',
                        achievement: '',
                    }]
                });
            },
            onResponseDelete() {
                this.dialogDelete = false;
                this.checkAllFiscalYearData();
                this.clearForm();
            },
            deleteProgram(subjectIndex, programIndex) {
                this.deleteFormData = {
                    subjectIndex: subjectIndex,
                    programIndex: programIndex
                };
                this.dialogProgramIndexDelete = true;
            },
            deleteProgramConfirmed() {
                this.subjects[this.deleteFormData.subjectIndex].programs.splice(this.deleteFormData.programIndex, 1);
                this.dialogProgramIndexDelete = false;
            },
            onResponseProgramClose() {
                this.dialogProgramIndexDelete = false;
            },
            addSubject() {
                this.subjects.push({
                    fiscalYearID: this.subjectFormData.fiscalYearID,
                    subjectTitleID: 0,
                    programs: [
                        {
                            programName: '',
                            targets: [{
                                targetName: '',
                                currentAmount: 0,
                                capitalAmount: 0,
                                anusuchiName: '',
                                achievement: '',
                            }]
                        }
                    ]
                });
            },
            deleteSubjectIndex(subjectIndex) {
                this.deleteFormData = {
                    incomeIndex: subjectIndex
                };
                this.dialogIndexDelete = true;
            },
            deleteConfirmed() {
                this.subjects.splice(this.deleteFormData.incomeIndex, 1);
                this.dialogIndexDelete = false;
            },
            onResponseClose() {
                this.dialogIndexDelete = false;
            },
            checkAllFiscalYearData() {
                axios.get("ReportSettings/GetPoliciesProgramBudgetLevelTwoByID/" + this.subjectFormData.fiscalYearID).then(response => {
                    this.rows = response.data
                })
            },
            subjectInfo(item) {
                axios.get("ReportSettings/GetPoliciesProgramBudgetLevelTwoByIDandSubjectID/" + item.fiscalYearID + "/" + item.subjectTitleID).then(response => {
                    this.subjects = response.data
                    this.isInitial = false
                })
            },
            clearForm() {
                this.subjects = [
                    {
                        fiscalYearID: this.subjectFormData.fiscalYearID,
                        subjectTitleID: 0,
                        programs: [
                            {
                                programName: '',
                                targets: [{
                                    targetName: '',
                                    currentAmount: 0,
                                    capitalAmount: 0,
                                    anusuchiName: '',
                                    achievement: '',
                                }]
                            }
                        ]
                    }
                ],
                    this.isInitial = true,
                    this.report.fiscalYearID= 0,
                    this.report.anusucharuReportID= 0
            },
            fiscalyear() {
                axios.get("ReportSettings/GetFiscalYearList").then(response => {
                    this.fiscalYearList = response.data
                })
            }
        },
        created() {
            this.loadItems()
            this.checkAllFiscalYearData()
            this.fiscalyear()

        },

    }
</script>

<style scoped>
</style>
